import { render } from "./OverallResult.vue?vue&type=template&id=72244696&scoped=true&ts=true"
import script from "./OverallResult.vue?vue&type=script&lang=ts"
export * from "./OverallResult.vue?vue&type=script&lang=ts"

import "./OverallResult.vue?vue&type=style&index=0&id=72244696&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72244696"]])

export default __exports__